import tirupatiImg from '../../../assets/tour-packages-img/tirupati-balaji-darshan-img.jpg';
import shirdiImg from '../../../assets/tour-packages-img/shirdi-shanisinganapur-img.jpg';
import maduraiRameshwaramImg from '../../../assets/tour-packages-img/madurai-rameshwaram-img.jpg';
import bangaloreSightSeeingImg from '../../../assets/tour-packages-img/bangalore-sight-seeing-img.webp';
import mysoreSightSeeingImg from '../../../assets/tour-packages-img/mysore-sight-seeing-img.jpg';
import mysoreOotyCoonoorImg from '../../../assets/tour-packages-img/mysore-ooty-coonoor-img.jpg';
import ootyKodaikanalImg from '../../../assets/tour-packages-img/ooty-kodaikanal-img.webp';
import munnarImg from '../../../assets/tour-packages-img/munnar-thekkady-img.jpg';
import goaImg from '../../../assets/tour-packages-img/goa-beach-city-img.webp';
import pondicherryMahabalipuramImg from '../../../assets/tour-packages-img/pondicherry-mahabalipuram-img.jpg';
import coorgHomeStayImg from '../../../assets/tour-packages-img/coorg-with-home-stay-img.webp';
import hyderabadRamojiImg from '../../../assets/tour-packages-img/hyderabad-ramoji-img.jpg';
import shimlaManaliImg from '../../../assets/tour-packages-img/shimla-kullu-manali-img.jpg';
import delhiAgraJaipurImg from '../../../assets/tour-packages-img/delhi-agra-jaipur-img.jpg';


export const tirupatiData = {
    title: "Tirupati Balaji Sheegra Darshan",
    sections: [
        {
            showTitle: "Package Includes :",
            items: [
                "UP / DOWN JOURNEY BY A/C VOLVO MULTIAXLE COACH / A/C Sleeper Coach",
                "REFRESHMENT ROOM WITH HOT WATER",
                "BREAKFAST / LUNCH (PURE VEG) + TIME FOR HAIR TENURE",
                "PADMAVATI & BALAJI DARSHAN + PRASADAM",
                "RS. 300/- SPL. DARSHAN TKT INCLUDED IN FARE",
                "DEVOTEES MUST CARRY ID PROOF",
                "DRESS CODE : GENTS : DHOUTHI / UTTARIYAM OR KURTA / PYJAM",
                "FOR LADIES : SAREE / CHOODIDHAR (JEANS NOT ALLOWED)",
            ],
        },
    ],
    highlights: ["Please Confirm Booking Before 7 Days for this trip"],
    image: tirupatiImg,
};



export const shirdiData = {
    title: "Shirdi - Shanisinganapur",

    sections: [
        {
            showTitle: "Shirdi (1 Night Stay)",
            items: [
                "Samadhi Mandir, Gurustan, Lendibagh, Dwarakamai, Chawdi, Hanuman Mandir, Ganesh Mandir, Shani Mandir, Mhalasapati Temple.",
                "Up & Down Journey by A/C Sleeper",
                "1 Night Stay at Shirdi",
                "Shanisinganapur Visit by Car",
            ],
        },

        {
            showTitle: "Shanisinganapur :",
            items: [
                "Lord Shanidev, Sakuri Samadhi Of Upasani Maharaj, Godavari Matha, Renuka Matha (Glass Temple).",
            ],
        },

        {
            showTitle: "NASIK : (2 Night Stay Covers Nasik & Ellora)",
            items: [
                "Mukthidham, Tryambakeswar, Panchavati, Kalaram...",
            ],
        },

        {
            showTitle: "ELLORA :",
            items: [
                "Guru Shaneswar Temple, Ellora Caves...",
            ],
        },
    ],

    highlights: [
        "PKG FARE DEPENDS ON BUS : NON A/C SEMI SLEEPER | SLEEPER A/C VOLVO | A/C SLEEPER",
        "PACKAGE INCLUDES UP & DOWN JOURNEY | SIGHTSEEING | ACCOMODATION",
    ],

    image: shirdiImg,
};



export const maduraiRameshwaramData = {
    title: "Madurai Rameshwaram Kanyakumari",

    sections: [
        // 🔹 DAY WISE DETAILS
        {
            items: [
                "Day 1 Night Departure from Bangalore by Sleeper Coach",

                "Day 2 Arrival at Madurai Check In Hotel after Refresh Proceed to Sight Seeing by Mini Bus Evening Back to Hotel Night Stay",

                "Day 3 Proceed to Rameshwaram Sight Seeing by Mini Bus. Evening Back to Kanyakumari Night Stay",

                "Day 4 Check Out Proceed to Kanyakumari Sight Seeing by Mini Bus. Evening Back to Madurai Night Departure to Bangalore",
            ],
        },

        // 🔹 MADURAI
        {
            showTitle: "Madurai :",
            items: [
                "Meenakshi Temple, Chokanandhar Temple, Alagar Temple, Murugan Temple, Mariamman Tank, Nayakar Mahal, Gandhi Museum.",
            ],
        },

        // 🔹 RAMESHWARAM
        {
            showTitle: "Rameshwaram :",
            items: [
                "Hanuman Temple, Pumban Bridge, Kashi Viswanatha Temple 24 Kundalas, Ram Parvath, Sita Parvath, Hanuman Parvath, Vishnu Temple",
            ],
        },

        // 🔹 KANYAKUMARI
        {
            showTitle: "Kanyakumari :",
            items: [
                "Sunrise Point, Triveni Sangam, Gandhi Mantapam, Kamarajmani Mantapam, Devikumari Amman Temple, Vivekananda Rock, Tiruvalluvar Statue, Surendran Temple, Hanuman Statue.",
            ],
        },
    ],

    // 🔴 RED HIGHLIGHTS (BOTTOM)
    highlights: [
        "Package Includes Up & Down Journey | Sightseeing | Accommodation",
        "PKG FARE DEPENDS ON BUS : NON A/C SEMI SLEEPER | SLEEPER A/C VOLVO | A/C SLEEPER",
        "PACKAGE INCLUDES UP & DOWN JOURNEY | SIGHTSEEING | ACCOMMODATION",
    ],

    image: maduraiRameshwaramImg,
};




export const bangaloreSightSeeingData = {
    title: "Bangalore Sight Seeing",

    sections: [
        {
            items: [
                "ISKON TEMPLE",
                "TIPPUS SUMMER PALACE",
                "KSIC EMPORIUM (SHOPPING)",
                "LALBAGH BOTANICAL GARDEN",
                "BULL TEMPLE",
                "VISWESWARAIAH MUSEUM",
                "VIDHANASOUDHA OUT VIEW",
                "HIGHCOURT OUT VIEW",
                "GUIDE / ENTRANCE FEE EXTRA",
            ],
        },
    ],

    image: bangaloreSightSeeingImg,
};



export const mysoreSightSeeingData = {
    title: "Mysore Sight Seeing",

    sections: [
        {
            items: [
                "SRI RANGANATHA SWAMY TEMPLE",
                "JUMMA MASJID - WATER GATE",
                "ST. PHILOMINA CHURCH",
                "CHAMUNDI HILLS",
                "BIG BULL",
                "MYSORE PALACE (SHOPPING TIME)",
                "ILLUMINATED BRINDAVAN GARDEN",
                "GUIDE / ENTRANCE FEE EXTRA",
            ],
        },
    ],

    // 🔴 Bottom important info (like design)
    highlights: [
        "Departure Bangalore : 7:00 AM - Arrival 11:30 PM",
    ],

    image: mysoreSightSeeingImg,
};



export const mysoreOotyCoonoorData = {
    title: "Mysore - Ooty - Coonoor",

    sections: [
        // 🔹 DAY 1
        {
            title: "Mysore (Day 1 Night Stay)",
            items: [
                "SRI RANGANATHA SWAMY TEMPLE, JUMMA MASJID - WATER GATE, ST. PHILOMINA CHURCH, CHAMUNDI HILLS - BIG BULL, MYSORE PALACE (SHOPPING TIME), ILLUMINATED BRINDAVAN GARDEN, GUIDE / ENTRANCE FEE EXTRA",
            ],
        },

        // 🔹 DAY 2
        {
            title: "Day 2 : Mysore to Ooty",
            items: [
                "Travel by Mini Bus, Enroute Visit Nanjangud Nanjundeshwara Temple, Bandipur Forest, OOTY Botanical Garden, Ooty Lake, Rose Garden, (Night Stay)",
            ],
        },

        // 🔹 DAY 3
        {
            title: "Day 3 : Coonoor Sight Seeing",
            items: [
                "Dolphin Nose, Valley View, Sims Park, Lambs Rock, Catherine Falls, Golf Club, Tea Garden, Doddabetta (South India's Largest Peak)",
            ],
        },

        // 🔹 FINAL
        {
            items: [
                "Night Departure to Bangalore",
            ],
        },
    ],

    // 🔴 IMPORTANT HIGHLIGHTS
    highlights: [
        "PKG FARE DEPENDS ON BUS : NON A/C SEMI SLEEPER | SLEEPER A/C VOLVO | A/C SLEEPER",
        "PACKAGE INCLUDES UP & DOWN JOURNEY | SIGHTSEEING | ACCOMMODATION",
    ],

    image: mysoreOotyCoonoorImg,
};







export const ootyKodaikanalData = {
    title: "OOTY - Kodaikanal",

    sections: [
        // 🔹 DAY 1
        {
            title: "Day 1 :",
            items: [
                "Night Departure from Bangalore by Sleeper Coach",
            ],
        },

        // 🔹 DAY 2
        {
            title: "Day 2 : OOTY",
            items: [
                "Arrival at Ooty Check In Hotel after Refresh, Proceed to Sight Seeing, Evening Back to Hotel Night Stay",
            ],
        },

        // 🔹 DAY 3
        {
            title: "Day 3 : Kodaikanal",
            items: [
                "Check Out from Ooty, Proceed to Kodaikanal by Govt Bus, Evening Arrival & Check In Hotel, Night Stay",
            ],
        },

        // 🔹 DAY 4
        {
            title: "Day 4 : Sight Seeing & Return",
            items: [
                "Check Out, Proceed to Sight Seeing, Evening Departure to Bangalore",
            ],
        },

        // 🔹 OOTY DETAILS
        {
            showTitle: "OOTY (Night Stay)",
            items: [
                "Botanical Garden, Ooty Lake, Rose Garden",
            ],
        },

        // 🔹 COONOOR
        {
            showTitle: "COONOOR Sight Seeing",
            items: [
                "Dolphin Nose, Valley View, Sims Park, Lambs Rock, Catherine Falls, Golf Club, Tea Garden, Doddabetta (South India's Largest Peak)",
            ],
        },

        // 🔹 KODAIKANAL
        {
            showTitle: "Kodaikanal (Night Stay)",
            items: [
                "Coakers Walk, Pillar Rocks, Green Valley View, Bear Shola Falls, Bryant Park, Silent Valley View, Kodai Lake (Boating), Kurunji Andavar Temple, Chattiyar Park, Silver Cascade, Science Museum",
            ],
        },
    ],

    // 🔴 IMPORTANT HIGHLIGHTS
    highlights: [
        "PKG FARE DEPENDS ON BUS : NON A/C SEMI SLEEPER | SLEEPER A/C VOLVO | A/C SLEEPER",
        "PACKAGE INCLUDES UP & DOWN JOURNEY | SIGHTSEEING | ACCOMMODATION",
    ],

    image: ootyKodaikanalImg,
};




export const munnarThekkadyAlleppeyData = {
    title: "Munnar - Thekkady - Alleppey - Cochin",

    sections: [
        // 🔹 DAY 1
        {
            title: "Day 1 :",
            items: [
                "Night Departure from Bangalore by Sleeper Coach",
            ],
        },

        // 🔹 DAY 2
        {
            title: "Day 2 : Munnar",
            items: [
                "Arrival at Munnar Check In Hotel after Refresh, Proceed to Sight Seeing by Individual Car, Evening Back to Hotel Night Stay",
            ],
        },

        // 🔹 DAY 3
        {
            title: "Day 3 : Munnar Sight Seeing",
            items: [
                "Proceed to Sight Seeing by Individual Car, Evening Back to Hotel Night Stay",
            ],
        },

        // 🔹 DAY 4
        {
            title: "Day 4 : Thekkady",
            items: [
                "Check Out from Munnar, Proceed to Thekkady Sight Seeing by Car, Evening Back to Hotel Night Stay at Thekkady",
            ],
        },

        // 🔹 DAY 5
        {
            title: "Day 5 : Alleppey House Boat",
            items: [
                "Check Out from Thekkady, Proceed to Alleppey, Check In House Boat, Sight Seeing Till Evening, Night Stay at House Boat (Including Food)",
            ],
        },

        // 🔹 DAY 6 (corrected)
        {
            title: "Day 6 : Cochin & Return",
            items: [
                "Check Out From House Boat, Proceed to Cochin Sight Seeing, Evening Departure to Bangalore",
            ],
        },

        // 🔹 MUNNAR DETAILS
        {
            showTitle: "Munnar : (2 Night Stay)",
            items: [
                "Photo Point, Mattupatti Dam & Lake, Indo-Swiss Project, Film Shooting Point, Echo Point, Elephant Spot, Kundale Lake / Dam, Kundale Golf Ground, Blossoms International Park, Top Station, Lakkam Falls, Marayoor, Chinnar, Pothamedu View Point, Cardamom & Coffee Plantation",
            ],
        },

        // 🔹 THEKKADY
        {
            showTitle: "Thekkady : (1 Night Stay)",
            items: [
                "Periyar Tiger Reserve, Boating, Elephant Ride (Optional), Spice Plantation View",
            ],
        },

        // 🔹 ALLEPPEY
        {
            showTitle: "Alleppey House Boat : (1 Night Stay)",
            items: [
                "Ancient Churches and Tiny Islands of Alleppey, Stay With Food",
            ],
        },

        // 🔹 COCHIN
        {
            showTitle: "Cochin :",
            items: [
                "Chinese Fishing Net, Harbour House, Santa Cruz Basilica Church, Dutch Palace, Bolgatty Palace, Edapalli Museum, Cherai Beach, Fort Kochi",
            ],
        },
    ],

    // 🔴 HIGHLIGHTS
    highlights: [
        "PKG FARE DEPENDS ON BUS : NON A/C SEMI SLEEPER | SLEEPER A/C VOLVO | A/C SLEEPER",
        "PACKAGE INCLUDES UP & DOWN JOURNEY | SIGHTSEEING | ACCOMMODATION",
    ],

    image: munnarImg,
};




export const goaBeachCityData = {
    title: "GOA Beach City",

    sections: [
        // 🔹 DAY 1
        {
            title: "Day 1 :",
            items: [
                "Night Departure from Bangalore by Sleeper Coach",
            ],
        },

        // 🔹 DAY 2
        {
            title: "Day 2 : GOA",
            items: [
                "Arrival at Goa Check In, Free Day (Boating Optional & Shopping), Night Stay",
            ],
        },

        // 🔹 DAY 3
        {
            title: "Day 3 : North Goa Sight Seeing",
            items: [
                "Proceed to North Goa Sight Seeing, Evening Back to Hotel Night Stay",
            ],
        },

        // 🔹 DAY 4
        {
            title: "Day 4 : South Goa & Return",
            items: [
                "Check Out, Proceed to South Goa Sight Seeing, Evening Departure to Bangalore",
            ],
        },

        // 🔹 NORTH GOA
        {
            showTitle: "NORTH GOA :",
            items: [
                "River Cruise, Calangute Beach, Fort Aguada, Light House Point, Aguada Beach, Vagator Beach, Anjuna Beach",
            ],
        },

        // 🔹 SOUTH GOA
        {
            showTitle: "SOUTH GOA :",
            items: [
                "Harbour Point, Bogmalo Beach, Old Goa Church, Colva Beach, Shri Mangueshi Temple, Shri Shantadurga Temple",
            ],
        },
    ],

    // 🔴 IMPORTANT HIGHLIGHTS
    highlights: [
        "PKG FARE DEPENDS ON BUS : NON A/C SEMI SLEEPER | SLEEPER A/C VOLVO | A/C SLEEPER",
        "PACKAGE INCLUDES UP & DOWN JOURNEY | SIGHTSEEING | ACCOMMODATION",
    ],

    image: goaImg,
};


export const pondicherryMahabalipuramData = {
    title: "Pondicherry - Mahabalipuram",

    sections: [
        // 🔹 DAY 1
        {
            title: "Day 1 :",
            items: [
                "Night Departure from Bangalore by Sleeper Coach",
            ],
        },

        // 🔹 DAY 2
        {
            title: "Day 2 : Pondicherry",
            items: [
                "Arrival at Pondicherry Check In Hotel after Refresh, Proceed to Sight Seeing by Car, Evening Back to Hotel Night Stay",
            ],
        },

        // 🔹 DAY 3
        {
            title: "Day 3 : Mahabalipuram & Return",
            items: [
                "Proceed to Mahabalipuram Sight Seeing by Car, Evening Back to Pondicherry, Night Departure to Bangalore",
            ],
        },

        // 🔹 PONDICHERRY DETAILS
        {
            showTitle: "Pondicherry : (1 Night Stay)",
            items: [
                "Sri Aurobindo Ashram, Promenade, Museum - Govt Square, Auroville Beach, Botanical Garden, Tree House, Chunnambar Beach, Manakula Vinayagar Temple, Bharathi Park",
            ],
        },

        // 🔹 MAHABALIPURAM
        {
            showTitle: "Mahabalipuram :",
            items: [
                "Temples, Beach",
            ],
        },
    ],

    // 🔴 IMPORTANT HIGHLIGHTS
    highlights: [
        "PKG FARE DEPENDS ON BUS : NON A/C SEMI SLEEPER | SLEEPER A/C VOLVO | A/C SLEEPER",
        "PACKAGE INCLUDES UP & DOWN JOURNEY | SIGHTSEEING | ACCOMMODATION",
    ],

    image: pondicherryMahabalipuramImg,
};



export const coorgHomeStayData = {
    title: "Coorg With Home Stay",

    sections: [
        // 🔹 DAY 1
        {
            title: "Day 1 :",
            items: [
                "Night Departure from Bangalore by Sleeper Coach",
            ],
        },

        // 🔹 DAY 2
        {
            title: "Day 2 : Coorg",
            items: [
                "Arrival at Coorg Check In Home Stay, Refresh & Proceed to Sight Seeing by Car, Evening Back to Home Stay Night Stay",
            ],
        },

        // 🔹 DAY 3
        {
            title: "Day 3 : Sight Seeing & Return",
            items: [
                "Check Out, Proceed to Sight Seeing, Sight Seeing Ends in Evening, Night Departure to Bangalore",
            ],
        },

        // 🔹 COORG DETAILS
        {
            showTitle: "Coorg With Home Stay :",
            items: [
                "Raja’s Seat, Fort, Omkareshwara Temple, Abbey Falls, Talacauvery, Bhagamandala, Golden Temple, Dubare Nisarga Dhama, Iruppu Falls, Nagarahole Wildlife Sanctuary, (For 2 Night Stay)",
            ],
        },
    ],

    // 🔴 IMPORTANT HIGHLIGHTS
    highlights: [
        "PKG FARE DEPENDS ON BUS : NON A/C SEMI SLEEPER | SLEEPER A/C VOLVO | A/C SLEEPER",
        "PACKAGE INCLUDES UP & DOWN JOURNEY | SIGHTSEEING | ACCOMMODATION",
    ],

    image: coorgHomeStayImg,
};




export const hyderabadRamojiData = {
    title: "Hyderabad Ramoji Film City",

    sections: [
        // 🔹 DAY 1
        {
            title: "Day 1 :",
            items: [
                "Night Departure from Bangalore by Sleeper Coach",
            ],
        },

        // 🔹 DAY 2
        {
            title: "Day 2 : Hyderabad",
            items: [
                "Arrival at Hyderabad Check In Hotel after Refresh, Proceed to Sight Seeing by Car, Evening Back to Hotel Night Stay",
            ],
        },

        // 🔹 DAY 3
        {
            title: "Day 3 : Ramoji Film City & Return",
            items: [
                "Check Out, Proceed to Ramoji Film City, Evening Back to Hyderabad, Night Departure to Bangalore",
            ],
        },

        // 🔹 HYDERABAD DETAILS
        {
            showTitle: "Hyderabad Ramoji Film City :",
            items: [
                "Salarjung Museum, Charminar, Birla Temple, Qutub Minar, Lumbini Park, Snow World, Golconda Fort, Nehru Zoo Park, Car Museum, NTR Park, Necklace Road, Hitech City, Hyderabad Central, RMR Falls, Ramoji Film City (One Day Visit)",
            ],
        },
    ],

    // 🔴 IMPORTANT HIGHLIGHTS
    highlights: [
        "PKG FARE DEPENDS ON BUS : NON A/C SEMI SLEEPER | SLEEPER A/C VOLVO | A/C SLEEPER",
        "PACKAGE INCLUDES UP & DOWN JOURNEY | SIGHTSEEING | ACCOMMODATION",
    ],

    image: hyderabadRamojiImg,
};






export const shimlaManaliData = {
    title: "Shimla Kullu Manali Tour Package",

    image: shimlaManaliImg,

    itinerary: [
        {
            day: "DAY 1: DELHI – MANALI (530 KMS/ 12-14 HRS) (OVERNIGHT JOURNEY)",
            lines: [
                "Day Services: Volvo Only",

                "We will receive you in New-Delhi at Volvo pick-up point. Your journey into the sparkling land of Himachal Pradesh starts from here. The overnight journey takes you through cities and your morning will be greeted with the fresh air of Manali.",

                "Exotic Manali offers something special for everyone. It gives peace to mediators; inspiration to artists, daring Activities for adventure Seekers and this list just goes on. As soon as you enter into the terrains of Manali, you will feel the cool breeze already taking all your stress away and surprising you from its jaw- dropping landscapes.",
            ],
        },

        {
            day: "DAY 2: ARRIVAL IN MANALI + LOCAL CITY TOUR (3 - 4 HRS TOUR)",
            lines: [
                "Day Services: Stay, Dinner & Car",

                "Major Attractions: Hadimba Mata Temple, Club House, Tibetan Monastery, Vashisht’s Hot Springs.",

                "Upon reaching Manali Stop, our team will greet you and transfer you to the hotel (Check in time will be 12:00 noon and early check-in will be subject to availability and an extra charge applies). Wake up to the beauty of Manali, after Lunch, proceed for the day tour which includes your local sightseeing. Every new beginning should be honored with folded hands and so the first place to visit will be Hadimba Mata Temple along with Ghatotkacha Temple then a short visit to Club House where you can enjoy some Indoor activities and then further to Tibetan Monastery. Later take a bath in Sage Vashisht’s Hot Springs containing Medical properties (Do carry a towel). Right across the Hot spring are temples of Lord Shiva and Lord Ram .Evening you are free to roam on the famed Mall Road and indulge in local shopping and also try some of the native cuisines. Return to the hotel for dinner and overnight stay.",
            ],
        },

        {
            day: "DAY 3: MANALI – SOLANG VALLEY OR ROHTANG OR ATAL TUNNEL",
            lines: [
                "Day Services: Stay, Breakfast, Dinner & Car",

                "Major Attractions: Solang Valley, Adventure activities.",

                "After breakfast it is time for some adventures!",

                "Wake up to the sweet sound of nature and after breakfast head towards Solang Valley. This valley is famous for its adventure activities and you can try your hand at Paragliding, Zorbing, ATV Rides, Horse-riding, Trail-rides and so much more. Before indulging in these activities make sure to understand all safety protocols and measures.",

                "Option1. (Rohtang Pass) You can also visit Rohtang Pass – this will be solely at the discretion of the local & NGT governing authorities and at extra cost.",

                "Option2. (Atal Tunnel)",

                "You can also visit and drive – through the newly built Atal Tunnel, one of the highest Tunnels in the World. This tunnel acts as a gateway to the Lahaul & Spiti Valley. You can make a stop at the North-Portal of the tunnel for an amazing photo-shoot. This option will be at extra cost.",

                "Afterwards return to the hotel for dinner and a comfortable stay.",

                "Note: Kindly inform us to add these options at the time of booking.",

                "Winter Note: During Snowfall Solang valley sightseeing point will be covered if weather, road condition is clear and possibilities of vehicles to reach there, otherwise sightseeing up to Barrier Point will be provided.",
            ],
        },

        {
            day: "DAY 4: DAY TRIP TO KULLU -NAGGAR",
            lines: [
                "Day Services: Stay, Breakfast, Dinner & Car",

                "Major Attractions: Kullu Pashmina Shawl showrooms. White Water River Rafting and Paragliding, Naggar Castle, Roerich Art Gallery.",

                "After breakfast, visit Kullu (40 Kms from Manali) while on the way taking a halt at Kullu Pashmina Shawl showrooms. White water River Rafting will be the highlight of the tour, so do not miss it. Resume your trip to Naggar (20 Kms from Manali). Reach and admire the heritage of Naggar Castle. This castle was once the abode of Kullu Raja and is now a hotspot for National & International Movie shootings. Later we will drive to Roerich Art Gallery while enroute catching the glimpses of Tripura Sundri Temple (one of the 51 Shakti Peethas). This gallery is one of the places where you can find original paintings of famous Russian Painter Nicholas Roerich. Later returned to Manali while taking a stroll at Trout Fish Farm. In this farm, one can order fresh trout platters while enjoying their time in the midst of birds and flowers. Overnight stay will be at Manali hotel.",

                "Note: Roerich Art Gallery is closed every Monday.",
            ],
        },

        {
            day: "DAY 5: MANALI – SHIMLA (240 KMS/7-8 HRS)",
            lines: [
                "Day Services: Stay, Breakfast, Dinner & Car",

                "Major Attractions: Enroute Mata Vaishno Devi Temple kullu, Hanogi Mata, Pandoh Dam and Sundernagar Lake.",

                "Today after your breakfast, check out from the hotel and head towards “The Queen of Hills”- Shimla, a deluxe bus / cab on a sharing basis. On the way make a short halt at Mata Vaishno Devi Temple kullu and get the glimpses of the Pandoh Dam,Hanogi Mata and Sundernagar Lake. Upon arrival, check-in to your pre-booked hotel for a healthy meal and a comfortable stay.",
            ],
        },

        {
            day: "DAY 6: KUFRI + SHIMLA LOCAL",
            lines: [
                "Day Services: Stay, Breakfast, Dinner and Car",

                "Major Attractions: Himalayan wildlife zoo, Kufri Fun Park, Scandal Point, Ridge, Gaiety Theatre, Heritage Museum, Lakkar Bazaar, Rani Jhansi Park and Christ Church.",

                "Today explore the Capital City of Himachal Pradesh. After a scrumptious breakfast, head towards Kufri.. Kufri is a world famous destination which attracts everyone. Here you can partake in adventure activities such as Horse-riding, Cycling, Yak-riding, Zip-lining, Tobogganing and so much more, or simply enjoy the open meadows, with majestic mountainous peaks and relax. Later head back to the main town of Shimla and cover places like Scandal Point, Ridge, Gaiety Theatre, Heritage Museum, Lakkar Bazaar, Rani Jhansi Park and Christ Church. Later back to the hotel for dinner and overnight stay.",
            ],
        },

        {
            day: "DAY 7: SHIMLA – DELHI DEPARTURE (DAY JOURNEY)",
            lines: [
                "Day Services: Breakfast & Volvo",

                "After your breakfast, check out from the hotel and head towards the Volvo Stand on the given time for your onward journey to Delhi. This completes your Glory of Shimla and Manali Holiday Package with Bharat Booking Holidays with beautiful and everlasting memories. We hope that you make us a part of another journey in the future.",
            ],
        },
    ],

    footer: [
        "Tour Ends but Sweet Memories Always Remains same.",
        "Package Name: Himachal Harmony (by Volvo)",
        "Tour Route: Delhi (Overnight) – Manali (3N) – Shimla (2N) – Delhi",
        "Duration: 5 Nights/6 Days",
        "Number of Travellers: 2 persons",
    ],
};






export const delhiAgraJaipurData = {
    title: "Delhi - Agra - Jaipur ",

    image: delhiAgraJaipurImg,

    itinerary: [
        {
            day: "DAY 01: DELHI RAILWAY STATION / AIRPORT – HOTEL + HALF DAY SIGHTSEEING",
            lines: [
                "Day Services: Stay, Car Only",

                "Meet & Greet on arrival at Delhi Railway Station / Airport & transfer to Hotel. On arrival check-in to the hotel. In the afternoon visit Rajghat, Jantar Mantar, Parliament House*, Rashtrapati Bhawan*, & India Gate. Overnight stay at Delhi. (*Drive Pass)",

                "Delhi, the capital of India, offers a sedate blend of culture, art and modern architecture. It attracts thousands of tourists every year with its mesmerizing natural scenic wonders and awe inspiring development. It also attracts a sea of professionals who visit the city for official purposes.",
            ],
        },

        {
            day: "DAY 02: DELHI – AGRA SIGHTSEEING (216 KM / 3 ½ HRS)",
            lines: [
                "Day Services: Breakfast, Stay & Car Only",

                "After Breakfast drive to another historical and romantic city – Agra. Enroute visit Sikandara – the mausoleum of Emperor Akbar. On arrival check-in to your hotel. Afternoon visit The world famous Taj Mahal – the most precious gift of love built by Emperor Shah Jahan for his loving wife Mumtaz and Also visit the Marble inlay making factories to see traditional workers making amazing marble crafts. Overnight stay at Agra.",

                "One of the world's seven wonders, the Taj Mahal, Agra is a city full of magnificent Mughal architecture. Although, there are so many more places to visit in Agra beyond Taj Mahal. Be it a family vacation, honeymoon, a solo trip or a group vacation with friends.",
            ],
        },

        {
            day: "DAY 03: AGRA – JAIPUR VIA FATEHPUR SIKRI (245 KM / 4 HRS)",
            lines: [
                "Day Services: Breakfast, Stay & Car Only",

                "After breakfast visit Agra Fort & proceed to the Pink City of Jaipur. Enroute visit Fatehpur Sikri – once the capital of Mughal Emperor Akbar. Also visit the Buland Darwaza, the largest gateway in the world. On arrival at Jaipur, check into your hotel. Overnight stay at Jaipur.",

                "Jaipur is also called the Pink City; Jaipur is the capital of the royal state of Rajasthan. Along with Delhi and Agra, Jaipur forms the Golden Triangle and hails as one of the most famous tourist circuits in the country. Rajputs ruled Jaipur for many centuries and developed it as a planned city in the 17th century AD. With the old city surrounded by walls and gates decorated with drawings on the backdrop of a beautiful pink hue, Jaipur, the pink city, successfully retains its old-world charm. Home to a few UNESCO World Heritage sites, including Amer Fort and Jantar Mantar, Jaipur holds many magnificent forts, palaces, temples and museums and brims with bustling local bazaars where you can shop to your heart's content. The city is also very well known for its local food, and the most famous dishes include the Ghewar, Pyaaz Kachori and Dal Baati Churma. The city also hosts the Jaipur Literary Festival, which is Asia's biggest festival of its kind.",
            ],
        },

        {
            day: "DAY 04: JAIPUR LOCAL SIGHTSEEING",
            lines: [
                "Day Services: Breakfast, Stay & Car Only",

                "After breakfast, at 10:00 am have Full Day Jaipur City Tour: City Palace Complex: The entire royal family of Jaipur resides in the resplendent Jaipur City Palace, better known as the Maharaja Sawai Man Singh II Museum, part of which is also open to the public, Jantar Mantar (Stone Observatory), Hawa Mahal: Hawa Mahal is famous because of its amazing and unique architecture. 953 windows or jharokhas are beautifully incorporated in the honeycomb design of this palace. In addition to providing a window to the outside world for the royal women, these windows helped in keeping the palace airy and cool, Jal Mahal & Amber Fort: Amber Fort is known for its artistic style elements. With its large ramparts and series of gates and cobbled paths, the fort overlooks Maota Lake, which is the main source of water for the Amber Palace. Mughal architecture greatly influenced the architectural style of several buildings of the fort.Till 6 Pm return to the Hotel. Overnight stay at Hotel.",
            ],
        },

        {
            day: "DAY 05: JAIPUR –DELHI RAILWAY STATION / AIRPORT (275 kms / 6 Hours)",
            lines: [
                "Day Services: Breakfast & Car Only",

                "After breakfast check out from the hotel and transfer to Delhi Railway Station / Airport for your onward journey.",
            ],
        },
    ],

    footer: [
        "Package Name: Golden Triangle",
        "Tour Route: Delhi (1N) – Agra (1N) – Jaipur (2N)",
        "Duration: 4 Nights/5 Days",
        "Number of Travellers: 02",
    ],
};